<!--近七日数据看板-->
<template>
  <Card :bordered="false" dis-hover class="menus-card">
    <p slot="title">{{ $t('home.my_menus') }}</p>
    <a href="#" slot="extra" class="extra-a">
      <system-tip
        tip-id="menusTip"
        :content="$t('home.tip_menusconfig')"
        class="menus-systemtip"
      ></system-tip>
      <i @click="clickItem" class="iconfont icon-newicon-peizhi"></i>
    </a>
    <div class="mymenus-container">
      <ul class="inner-container menus-ul">
        <li
          v-for="(menu, index) in subscribeMenus"
          class="item-li"
          @click="goRouter(menu)"
          :key="index"
        >
          <figure class="menu-item" :title="menu.privilegeDesc">
            <img :src="imgBaseUrl + menu.icon + '.png'" />
            <figcaption>{{ menu.privilegeDesc }}</figcaption>
          </figure>
        </li>
      </ul>
    </div>
    <menus-config
      @on-close="hideMenuConfig"
      @refresh="getData"
      :subscribe-list="subscribeMenus"
      :show-modal="display.showMenuConfig"
    ></menus-config>
  </Card>
</template>

<script>
import api from '../../../api/home/index';
import MenusConfig from '../components/menus-config.vue';
import SystemTip from '../../../components/system-tip.vue';
import { subscribeMenuList } from '../subscribeConfig';
export default {
  components: { MenusConfig, SystemTip },
  data() {
    return {
      menus: [],
      subscribeMenus: [],
      imgBaseUrl: process.env.BASE_URL + 'images/menus/',
      display: {
        showMenuConfig: false,
      },
    };
  },
  computed: {
    servers() {
      return this.$system.$state.servers;
    },
    menuList() {
      return this.$system.$state.menuList;
    },
    privileges() {
      return this.$system.$state.privileges;
    },
    routerList() {
      return this.$system.$state.routerList;
    },
  },
  mounted() {
    this.getData();
    this.listen();
  },
  methods: {
    listen() {},
    async getData() {
      const subscribes = [];
      let data = await api.getUserWebModules(null);
      //根据订阅id获取模块key列表
      data.forEach(item => {
        for (let sub in subscribeMenuList) {
          if (subscribeMenuList[sub].id == item.moduleCode) {
            subscribes.push({
              key: sub,
              icon: subscribeMenuList[sub].icon,
            });
            return;
          }
        }
      });
      //根据用户权限再次过滤，防止出现已订阅的模块被删除权限的情况
      const delArr = [];
      subscribes.forEach((sub, index) => {
        let i = this.privileges.findIndex(pri => {
          return pri.privilegeName === sub.key;
        });
        if (i !== -1) {
          subscribes[index].privilegeDesc = this.privileges[i].privilegeDesc;
        } else {
          delArr.push(index);
        }
      });
      delArr.sort(function (a, b) {
        return b - a;
      });
      delArr.forEach(d => {
        subscribes.splice(d, 1);
      });
      this.subscribeMenus = subscribes;
    },
    clickItem() {
      this.display.showMenuConfig = true;
    },
    hideMenuConfig() {
      this.display.showMenuConfig = false;
    },
    goRouter(menu) {
      let router = this.routerList[menu.key];
      this.$system.goRouter({ router });
    },
  },
};
</script>
<style lang="scss" type="text/scss">
.extra-a {
  color: inherit;
}
.menus-card {
  .menus-systemtip {
    width: 200px;
    left: -200px;
    z-index: 9;
  }
}
.mymenus-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .menus-ul {
    width: auto;
    max-width: 100%;
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .item-li {
    margin: 10px;
    cursor: pointer;
    width: 100px;
  }
  .menu-item {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    &:hover {
      color: $secondary-color-hover;
      img {
        border: 1px solid $secondary-color-hover;
        border-radius: 8px;
      }
    }
    img {
      width: 80px;
      height: 80px;
    }
    figcaption {
      margin-top: 5px;
      width: 100%;
      text-align: center;
      @include ellipsis;
    }
  }
}
@media screen and (min-width: 300px) and (max-width: 768px) {
  .mymenus-container {
    .item-li {
      margin: 10px 0;
      max-width: 120px;
      width: 33.3%;
    }
    .menu-item {
      &:hover {
        img {
          border-radius: 12px;
        }
      }
      img {
        width: 50px;
        height: 50px;
      }
      figcaption {
        font-size: 12px;
      }
    }
  }
}
@media screen and (min-width: 1600px) {
  .mymenus-container {
    .item-li {
      width: 120px;
      margin: 20px;
    }
    .menu-item {
      &:hover {
        img {
          border-radius: 16px;
        }
      }
      img {
        width: 100px;
        height: 100px;
      }
      figcaption {
        font-size: 14px;
      }
    }
  }
}
</style>
